'use strict'

{ fetchJSON, recordViewedEvent, wireMessageClick } = require './helpers/inbox_helpers'
{ updateUnviewedCount, updateTimestamps } = require './presenters/inbox_presenter'
{ addReferrer } = require 'src/frontend/helper/general/m_userSessionAddReferrer'
presentBanner = require './presenters/banner_presenter'
bannerTemplate = require '../v6.0.html.mustache'

IAM_EVENTS = {
  NO_MESSAGE_ID: 'iam-no-message-id'
}

INBOX_SELECTORS = {
  BELL_CLASS: '#ls-header-main .ls-h-bell'
  FLYOUT_ID: 'ls-inbox-flyout'
  SHOW_CLASS: 'show'
  SHOW_ARROW_CLASS: 'show-arrow'
  TIMER_ATTR: 'lsTimer'
}

module.exports = do ->
  init: ->
    @bannerEl = document.getElementById('ls-in-app-messages')
    @inboxEl = document.querySelector(INBOX_SELECTORS.BELL_CLASS)
    return unless (@bannerEl or @inboxEl)
    @fetch()

  fetch: ->
    fetchJSON ({ inbox, banner }) =>
      if inbox and @inboxEl
        inboxFlyoutElem = document.getElementById(INBOX_SELECTORS.FLYOUT_ID)
        inboxFlyoutElem.innerHTML = inbox.html
        updateUnviewedCount(@inboxEl, inbox.unviewedCount)
        @wireEvents(@inboxEl, inboxFlyoutElem)

      banner ?= {}
      if banner?.message and @bannerEl
        if banner.id
          presentBanner(@bannerEl, banner, bannerTemplate)

  showFlyout: (inboxElem) ->
    updateTimestamps(inboxElem)
    recordViewedEvent(inboxElem)
    return

  wireEvents: (bellElem, inboxElem) ->
    wireMessageClick(inboxElem)
    addReferrer()

    bellElem.addEventListener 'mouseenter', ->
      updateUnviewedCount(bellElem, 0)
    , { once: true, passive: true }

    bellElem.addEventListener 'mouseenter', =>
      @showFlyout(inboxElem)
    , { passive: true }
